import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetPlayheadPositionMutationVariables = Types.Exact<{
  input: Types.SetPlayheadPositionInput;
}>;


export type SetPlayheadPositionMutation = { __typename?: 'Mutation', setPlayheadPosition?: boolean | null };


export const SetPlayheadPosition = /*#__PURE__*/ gql`
    mutation SetPlayheadPosition($input: SetPlayheadPositionInput!) {
  setPlayheadPosition(input: $input)
}
    ` as unknown as DocumentNode<SetPlayheadPositionMutation, SetPlayheadPositionMutationVariables>;

          

          export const useSetPlayheadPositionMutation = (options?:MutationHookOptions<SetPlayheadPositionMutation, SetPlayheadPositionMutationVariables>) => useMutation(SetPlayheadPosition, options);
          

          export type SetPlayheadPositionMutationOptions = MutationHookOptions<SetPlayheadPositionMutation, SetPlayheadPositionMutationVariables>;

          

          export type SetPlayheadPositionMutationResult = ReturnType<typeof useSetPlayheadPositionMutation>[1];

          
